import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { delay } from 'lodash';
import Link from 'redux-first-router-link';
import * as selectors from 'selectors';
import { toggleMenu } from 'actions';
import styles from './logo.css';

const pageStyles = {
  Works: 'fillWhite',
  Home: 'homeStyle',
  Agency: 'fillBlack',
  Reels: 'fillWhite',
  NotFound: 'fillWhite',
};

const LogoLink = styled(Link)`
  fill: ${({ menuOpen, colors }) => (menuOpen ? colors.logo : null)};
`;

class Logo extends React.Component {
  state = {
    animating: false,
  }


  onAnimationEnd = () => {
    delay(() => this.setState({ animating: false }), 300);
  }
  startAnimation = () => {
    const { animating } = this.state;

    if (!animating) {
      this.setState(() => ({ animating: true }));
    }
  }

  render() {
    const {
      menuOpen, page, className, colors,
    } = this.props;

    const { animating } = this.state;
    return (
      <LogoLink
        key={animating}
        className={cx(
          styles.logo,
          className,
          styles[pageStyles[page]],
          styles.logoDark,
          animating && styles.animating,

        )}
        title="Main page"
        to="/"
        menuOpen={menuOpen}
        colors={colors}
        onMouseEnter={this.startAnimation}
        onClick={this.startAnimation}
      >
        <svg
          className={styles.logoIcon}
          viewBox="0 0 105 33"
          width="105"
          height="33"
        >
          <path
            className={styles.g}
            d="M14.6,18.1v3.2h11.3c-0.7,4.9-4.8,8-10.6,8c-6.8,0-11.8-4.9-11.8-11.7c0-6.8,5-11.7,11.8-11.7&#xA;&#x9;&#x9;c4.1,0,7.8,2.2,9.5,5.5l0.1,0.3l3-1.7l-0.1-0.2c-2.5-4.4-7.3-7.1-12.5-7.1C6.5,2.7,0,9.2,0,17.7c0,8.5,6.5,15,15.2,15&#xA;&#x9;&#x9;c8.3,0,14.2-5.3,14.2-12.8v-1.7H14.6"
          />
          <path
            className={styles.e}
            d="M62.7,14.2c-1.9-2.2-4.6-3.4-7.6-3.4c-6.3,0-10.9,4.6-10.9,10.9c0,6.4,4.6,10.9,11.1,10.9&#xA;&#x9;&#x9;c3.9,0,7.3-1.7,9.2-4.8l0.1-0.2L61.8,26l-0.1,0.2c-1.2,2.1-3.5,3.3-6.3,3.3c-4.1,0-7.1-2.4-7.8-6.1h17.8l0-0.3&#xA;&#x9;&#x9;c0-0.4,0.1-0.9,0.1-1.3C65.4,19,64.5,16.3,62.7,14.2 M55.1,14c4.1,0,6.5,3.1,7,6.2H47.6C48.2,16.5,51.2,14,55.1,14z"
          />
          <path
            className={styles.a}
            d="M86.2,11.4v3.4c-1.9-2.5-4.7-3.9-7.9-3.9c-5.9,0-10.8,4.9-10.8,10.9c0,6,4.8,10.9,10.8,10.9&#xA;&#x9;&#x9;c3.2,0,6.1-1.4,7.9-3.9v3.4h3.2V11.4H86.2 M78.4,29.5c-4.3,0-7.7-3.4-7.7-7.8c0-4.4,3.4-7.8,7.7-7.8c4.3,0,7.7,3.4,7.7,7.8&#xA;&#x9;&#x9;C86.2,26.1,82.8,29.5,78.4,29.5z"
          />
          <path
            className={styles.t}
            d="M104.8,14.5v-3.2H99V5.6l-3.2,1v4.8h-4.3v3.2h4.3v12c0,2.1,0.5,3.5,1.6,4.5c1,0.9,2.5,1.4,4.5,1.4&#xA;&#x9;&#x9;c0.8,0,1.7-0.1,2.7-0.2l0.2,0v-2.9l-0.9,0c-0.7,0-1.3,0.1-1.8,0.1c-2.2,0-3.1-0.4-3.1-2.9v-12H104.8"
          />
          <polyline
            onAnimationEnd={this.onAnimationEnd}
            className={styles.r}
            points="44,14.1 42.6,11.2 35.5,14.6 35.5,11.4 32.2,11.4 32.2,32.2 35.5,32.2 35.5,18.2 44,14.1 &#x9;"
          />
        </svg>
      </LogoLink>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  hideMenu: () => dispatch(toggleMenu(false)),
});

const mapStateToProps = state => ({
  colors: selectors.getMenuLogoColors(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Logo);



// WEBPACK FOOTER //
// ./src/components/modules/Header/Logo.js